import React from "react";
import { useState } from "react";
import { Image, Stack } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { AiOutlineDelete } from "react-icons/ai";
import { MdAdd, MdRemove } from "react-icons/md";
import auth from "../../init.firebase";
import { useAddToCartNewDataByEmailMutation } from "../../redux/addToCart/addToCartApi";

const SingleProductCard = ({ cart }) => {
  const [currentQuantity, setCurrentQuantity] = useState(cart?.quantity);

  const [user] = useAuthState(auth);
  const userEmail = user?.email;

  const [
    addToCartNewDataByEmail,
    { isLoading: updateLoading, isError: updateError },
  ] = useAddToCartNewDataByEmailMutation();

  const quantityIncrease = (quantity) => {
    let q = currentQuantity + 1;

    setCurrentQuantity(q);

    const data = {
      product: cart.product._id,
      quantity: q,
    };
    addToCartNewDataByEmail({ userEmail, data });
  };

  const quantityDecrease = (quantity) => {
    let q = currentQuantity - 1;

    setCurrentQuantity(q);

    const data = {
      product: cart.product._id,
      quantity: q,
    };
    addToCartNewDataByEmail({ userEmail, data });
  };
  return (
    <Stack direction="horizontal" gap={3} className="pb-3 ">
      <div style={{ width: "100px" }}>
        <Image
          key={cart?._id}
          src={`${process.env.REACT_APP_IMAGE_URL}${cart?.product?.images[0]?.filename}`}
          style={{ width: "100px", height: "100px" }}
        />
      </div>
      <div className="w-100">
        <div style={{ fontSize: "14px", fontWeight: "bold" }}>
          {cart?.product?.name}
        </div>
        <div style={{ fontSize: "14px" }}>Size: 30ml</div>
        <div style={{ fontSize: "14px" }}>৳ {cart?.product?.price}</div>
        <div className="mt-2 d-flex align-items-center justify-content-between">
          <div
            className="d-flex align-items-center justify-content-between border"
            style={{ minWidth: "104px" }}
          >
            <button
              onClick={() => quantityDecrease(cart.quantity)}
              disabled={currentQuantity <= 1}
              style={{
                cursor: `${currentQuantity <= 1 ? "not-allowed" : "pointer"}`,
              }}
              cursor={"pointer"}
              className="px-2 py-1 d-flex align-items-center justify-content-center border-0 btn-decrease"
            >
              <MdRemove className="h6 m-0" />
            </button>
            {cart.quantity}
            <button
              onClick={() => quantityIncrease(cart.quantity)}
              cursor={"pointer"}
              className="px-2 py-1 d-flex align-items-center justify-content-center border-0 btn-increase"
            >
              <MdAdd className="h6 m-0" />
            </button>
          </div>
        </div>
      </div>
    </Stack>
  );
};

export default SingleProductCard;
